import { render, staticRenderFns } from "./igNore.vue?vue&type=template&id=3bc14217&scoped=true&"
import script from "./igNore.vue?vue&type=script&lang=js&"
export * from "./igNore.vue?vue&type=script&lang=js&"
import style0 from "./igNore.vue?vue&type=style&index=0&id=3bc14217&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc14217",
  null
  
)

export default component.exports